<template>
  <div class="home">
    <div class="container">
      <div class="top-content">
        <hot-news />
        <banner />
      </div>
      <div class="content">
        <category />
        <div class="list"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        >
          <product v-for="(item, index) in list" :key="index" :product="item" />
          <div class="page-box">
            <el-pagination
              @current-change="onChangePage"
              :page-size="pageQuery.pagesize"
              background
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import Banner from '@/components/banner/index.vue'
import HotNews from '@/components/hot-news/index.vue'
import Category from '@/components/category/index.vue'
import Product from '@/components/product/index.vue'

import { getAssetsList } from '@/api/assets'

export default {
  name: 'HomeView',
  components: {
    Banner,
    HotNews,
    Category,
    Product,
  },
  data() {
    return {
      list: [],
      pageQuery: {
        type: 0,
        page: 1,
        pagesize: 10
      },
      total: 10,
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onChangePage(page) {
      this.pageQuery.page = page
      this.getList()
    },
    getList() {
      this.loading = true
			getAssetsList(this.pageQuery).then((res) => {
        this.loading = false
				if (res.code === 200 && res.data) {
					this.list = res.data.list
          this.total = res.data.total
				}
			})
		},
  }
}
</script>
<style scoped lang="scss">
.top-content {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.box {
  width: 100px;
  height: 100px;
  background-color: $red;
}
.content {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .list {
    width: 870px;
  }
}
.page-box {
  margin-top: 20px;
  text-align: center;
}
</style>
